import request from "@/utils/request";
const jsApiHost = process.env.VUE_APP_GENERAL_API_HOST

export function getEquipEventListApi(params) {
  return request({
    url: jsApiHost + "/equip/event/list",
    method: "get",
    params
  });
}

export function getEquipLatestEventListApi(params) {
  return request({
    url: jsApiHost + "/equip/visit/latestEvent",
    method: "get",
    params
  });
}

export function getEventOrderlogApi(params) {
  return request({
    url: "?c=rms&a=event&do=equip",
    method: "get",
    params
  });
}

export function getEquipEventScatterApi(days) {
  return request({
    url: "?c=rms&a=event&do=equip-dot",
    method: "get",
    params: {
      days: days
    }
  });
}

export function getUserEventScatterApi(days) {
  return request({
    url: "?c=rms&a=event&do=user-dot",
    method: "get",
    params: {
      days: days
    }
  });
}

export function getVisitStatsApi() {
  return request({
    url: jsApiHost + "/equip/visit/curve",
    method: "get"
  });
}

export function eventOrderlogApi(query) {
  return request({
    url: "?c=rms&a=event&do=orderlog",
    method: "get",
    params: {
      pindex: query.pindex,
      psize: query.psize,
      memberid: query.memberid,
      equipid: query.equipid,
      starttime: query.dateRange ? query.dateRange[0] : undefined,
      endtime: query.dateRange ? query.dateRange[1] : undefined
    }
  });
}

export function getLatestVisitApi(params) {
  return request({
    url : jsApiHost + "/equip/visit/latestVisit",
    method: "get",
    params
  });
}

export function getVisitRankApi(params) {
  return request({
    url: "?c=sa&a=equip&do=visit-rank",
    method: "get",
    params
  });
}

export function getAlarmRankApi(params) {
  return request({
    url: "?c=sa&a=equip&do=alarm-rank",
    method: "get",
    params
  });
}
